module.exports = __webpack_public_path__ + "img/28200.56e966aa.jpg";